export const Metrics = {
    Generic: 'generic',
    Brand: "brand",
    Section: "section"
}

export const UserType = {
    Admin: 'admin',
    User: 'user'
}

let environment = `${process.env.MIX_APP_ENV}_`

if (process.env.VUE_APP_ENVIRONMENT === 'production') {
    environment = ''
}

export const Tokens = {
    Personal: `${environment}analytics_personal_token`,
    Client: `${environment}analytics_client_token`,
    Filters: `${environment}filters`,
    Sections: `${environment}sections`,
    Indications: `${environment}indications`,
    Specialties: `${environment}specialties`,
    MenuNav: `${environment}menu_nav`,
}

export const TextStyleKeys = [
    'align',
    'fontSize',
    'color',
    'fontStyle'
];

export const ContainerStyleKeys = [
    'width',
    'align',
    'position',
    'bgColor',
];

export const TableDataStyleKeys = [
    // 'bgColor',
    // 'headerBgColor',
    // 'altBgColor',
    'borderColor',
    'fontSize',
    'fontColor'
];

export const SectionKey = `${process.env.MIX_APP_ENV}_sections`;

export const userNavigation = [
    // { name: "Your Profile", type: 'profile', href: "#" },
    // { name: "Settings", type: 'settings', href: "#" },
    { name: "Sign out", type: 'signout', href: "#" },
]

export const Permutation = {
    Geographic: "geographic",
    DrugInfo: "drug-info",
    Demographic: "demographic"
}

export const Navigation = [
    "Therapeutic Class",
    "Specialties",
    "Indications",
    "Brands",
    "Generics",
    "Reports"
]

export const ReportAction = [
    { name: "Edit", type: 'edit', href: "#" },
    { name: "Delete", type: 'delete', href: "#" }
]

export const AdditionalColumn = [
    {
        label: "Include Generic Component",
        value: 'generic'
    },
    {
        label: "Include Therapeutic Class",
        value: 'therapeutic_class'
    },
    // {
    //     label: "Include Company name",
    //     value: 'company_name'
    // },
    {
        label: "Cumulative",
        value: 'cumulative',
    },
    {
        label: "Quarter Column",
        value: 'quarter',
    }
]
